import {ISpecialtyCommittee} from '../../utils/CommitteeList';
import {Card, Col, Divider, Popover, Row, Tabs} from 'antd';
import React from 'react';
import userBg from '../../assets/user-bg.png';
import scscv2026Banner from '../../assets/scscv-2026.jpg';
import Flex from '../Flex';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';

const SCSCV_2026_BANNER = {
  committeeName: '计算机视觉专业委员会',
  href: 'http://scs.sh.cn/#/scscv/SCSCV2026',
  alt: '第四届（2026）上海计算机视觉学术年会',
  src: 'https://scs-official-web.oss-cn-hangzhou.aliyuncs.com/scscv/banner.jpg',
};

function renderUser(name: string, group: string, email: string) {
  return (
    <Flex align={'center'} style={{fontSize: 14, fontWeight: 'normal', color: 'black', marginBottom: 4}}>
      <div style={{width: 60, marginRight: 20}}>{name}</div>
      <div style={{width: 240, marginRight: 20, fontSize: 12}}>{group}</div>
      <div style={{fontSize: 12}}>{email}</div>
    </Flex>
  );
}
export default function CommitteeInfo(props: {info: ISpecialtyCommittee}) {
  const committeeBanner = props.info.name === SCSCV_2026_BANNER.committeeName ? SCSCV_2026_BANNER : undefined;

  return (
    <Card
      className={'m-b-10'}
      title={
        <div style={{fontSize: 22}}>
          {props.info.name}
          {/*<Tabs>*/}
          {/*  <Tabs.TabPane>专委会简介</Tabs.TabPane>*/}
          {/*  <Tabs.TabPane>组织名单</Tabs.TabPane>*/}
          {/*</Tabs>*/}
        </div>
      }>
      <div style={{position: 'relative', overflow: 'hidden'}}>
        <div style={{zIndex: 2, position: 'relative', paddingBottom: 20}}>
          {committeeBanner && (
            <a href={committeeBanner.href} style={{display: 'block'}}>
              <img src={committeeBanner.src} alt={committeeBanner.alt} style={{display: 'block', width: '100%', height: 'auto', marginBottom: 20}} />
            </a>
          )}
          <Paragraph style={{fontSize: 16}}>{props.info.description}</Paragraph>

          {props.info.list?.map((item, i) => (
            <React.Fragment key={item.title}>
              <Divider />
              <div
                style={{
                  fontSize: 19,
                  fontWeight: 'bold',
                  color: '#0b4d8d',
                  marginBottom: 10,
                }}>
                {item.title}
              </div>
              <Row>
                {item.members.map(user => (
                  <Col span={4} key={user.name}>
                    <Popover
                      trigger={'hover'}
                      placement={'right'}
                      content={
                        <div style={{width: 500}}>
                          <Flex align={'flex-end'}>
                            <div style={{fontSize: 22, color: 'black'}}>{user.name}</div>
                          </Flex>
                          <Flex className={'m-b-5'}>
                            <div className={'m-r-10'}>{user.group}</div>
                            <div>{user.email}</div>
                          </Flex>
                          <Paragraph>{user.description}</Paragraph>
                        </div>
                      }>
                      <a>
                        <Flex direction={'column'} align={'center'} justify={'center'}>
                          <img src={`https://scs-official-web.oss-cn-hangzhou.aliyuncs.com/images/${user.name}.jpg`} style={{height: 100}} alt="" />
                          <div style={{fontWeight: 'bold', color: 'black', fontSize: 16, marginTop: 4}}>{user.name}</div>
                          <div className={'text-center'}>
                            <Text type={'secondary'} className={'text-center'}>
                              {user.group}
                            </Text>
                          </div>
                        </Flex>
                      </a>
                    </Popover>
                  </Col>
                ))}
              </Row>
            </React.Fragment>
          ))}
        </div>
        <img src={userBg} style={{position: 'absolute', bottom: 0, right: 0, width: 500, opacity: 0.3}} alt="" />
      </div>
    </Card>
  );
}
